if ($('.sp-change-together')) {
    const spChangeTogetherMapObjects = [

        // 1 Кинотеатр
        {
            title: "Кинотеатр «Молодость»",
            address: "пр-т Мира, 30А",
            desc: "<p>«Молодость» — один из самых узнаваемых объектов Амурска. В 2019 году, в год его 55-летия, выполнена комплексная модернизация здания. Финансирование осуществлялось из разных источников: Фонд кино, городская администрация, «Полиметалл» и собственные средства кинотеатра. Отремонтирована прилегающая территория и фасад здания, в зале смонтированы новые кресла, освещение, акустические панели и аудиосистема. Этот единственный в Амурском районе кинотеатр показывает в год более 100 фильмов, одновременно может вместить 184 зрителя. Все российские премьеры в кинотеатре идут день в день с показом по стране.</p>",
            link: "https://proamursk.ru/news/100/"
        },

        // 2 Дворец культуры
        {
            title: "Дворец культуры",
            address: "Комсомольский пр-т, 48",
            desc: "<p>Дворец культуры — визитная карточка Амурска. Здесь проходит насыщенная культурная жизнь не только города, но и всего района.</p><p>К обновлению объекта подходили комплексно и в течение нескольких лет. Были отремонтированы большой зрительный зал и фойе, преобразились кинофойе, комната торжеств, спортивный и паркетный залы, а также лестничные марши. А в 2024 году завершен долгожданный ремонт малого зала ДК.</p>",
            link: "https://proamursk.ru/news/1217/"
        },

        // 3 Автовокзал
        {
            title: "Автовокзал",
            address: null,
            desc: "В 2019 году при финансовой поддержке компании «Полиметалл» завершился ремонт общественной территории автовокзала. Полностью восстановлена и модернизирована остановочная станция: отремонтирована крытая остановка, установлены новые лавочки, световые короба и информационные стенды, современные светофоры на солнечных батареях. Также проведены работы по благоустройству и озеленению территории.",
            link: "https://proamursk.ru/news/82/"
        },

        // 4 Ботсад
        {
            title: "Ботанический сад Амурского района",
            address: "ул. Школьная, 11",
            desc: "<p>Ботанический сад — настоящая жемчужина Амурска и всего Хабаровского края. Здесь собраны растения со всех уголков нашей планеты. В саду насчитывается свыше 2500 видов тропических, субтропических, суккулентных и кактусовых растений, среди которых около 20 видов краснокнижных видов и эндемиков.</p><p>При поддержке «Полиметалла» в 2018 году был открыт класс-оранжерея для изучения экологии и биологии. А в 2022 году завершены работы по благоустройству территории. На площадке появились пешеходные дорожки, зоны отдыха, клумбы и топиарные фигуры. Теперь прилегающая территория «зеленого уголка» Амурска стала современной и красивой.</p>",
            link: "https://proamursk.ru/news/882/ "
        },

        // 5 Городской парк
        {
            title: "Городской парк культуры и&nbsp;отдыха",
            address: null,
            desc: "<p>В июне 2023 года городской парк в Амурске получил вторую жизнь благодаря совместным усилиям администрации города и компании «Полиметалл». В проекте была задействована команда профессионалов — проектировщики, дизайнеры, строители.</p><p>На территории парка установлены детские игровые комплексы, качели, туристические полосы, построена универсальная площадка для занятий футболом и баскетболом. Многие конструкции парка выполнены из экологически чистого материала — дерева.</p>",
            link: "https://proamursk.ru/reports/391/"
        },

        // 6 Роллердром
        {
            title: "Роллердром",
            address: null,
            desc: "<p>Проект по строительству первого современного роллердрома при поддержке «Полиметалла» был реализован в 2019 году. Спортивный объект площадью 1500 квадратных метров расположен в самом центре Амурска — в городском парке.</p><p>Роллердром пользуется большой популярностью как у профессиональных скейтеров и роллеров, так и у юных амурчан. Пространство площадки зонировано на 12 трюковых модулей, по периметру смонтировано освещение. Также на территории роллердрома есть велопарковка и скамейки для отдыха.</p>",
            link: "https://proamursk.ru/news/81/"
        },

        // 7 Спортивная школа
        {
            title: "Спортивная школа",
            address: "ул. Амурская, 3А",
            desc: "<p>Главный спортивный объект города, который благодаря финансовой поддержке компании «Полиметалл» за несколько лет изменил свой облик. Масштабный ремонт преобразил зал для игровых видов спорта, стали современными раздевалки и душевые комнаты, оснащен зал бокса, отремонтирован плавательный бассейн, благоустроена прилегающая территория спортивного комплекса.</p><p>Спортивную школу посещают около 1100 юных амурчан. На базе учреждения обучают таким видам спорта, как бокс, футбол, борьба, плаванье, лыжные гонки, северное многоборье, дартс, спортивный туризм, пауэрлифтинг.</p>",
            link: "https://proamursk.ru/news/634/"
        },

        // 8 Амурская ЦРБ
        {
            title: "Амурское подразделение городской больницы им. М.И. Шевчук",
            address: null,
            desc: "<p>«Полиметалл» уделяет особое внимание ремонту и материально-техническому оснащению отделений Амурской районной больницы.</p><p>Благодаря финансовой поддержке компании реализована большая программа по оснащению современным диагностическим оборудованием: приобретены гистологический и неонатальный мониторы, аппарат для искусственной вентиляции легких, современный рентген-аппарат, блоки бесперебойного питания для спирального компьютерного томографа, отремонтирован аппарат СКТ. Кроме того, отремонтировано здание женской консультации, в хирургическом корпусе заменены окна.</p>",
            link: "https://proamursk.ru/news/623/"
        },

        // 9 Женская консультация
        {
            title: "Женская консультация",
            address: "пр-т Строителей, 21",
            desc: "<p>Одно из старейших медицинских учреждений Амурска. Женская консультация является единственной в Амурском районе и обслуживает более 20 тысяч посетительниц ежегодно. В 2019 году благодаря финансированию компании «Полиметалл» сделан долгожданный ремонт в здании, что позволило врачам вести комфортный прием, а посетителям — ожидать своей очереди в обновленных коридорах с кондиционерами.</p>",
            link: "https://proamursk.ru/reports/158/"
        },

        // 10 Стоматологическая поликлиника
        {
            title: "Стоматологическая поликлиника",
            address: "пр-т Мира, 46А",
            desc: "<p>При поддержке компании «Полиметалл» в Амурской стоматологической поликлинике ранее был переоборудован стоматологический кабинет для работы врача-хирурга. А в ноябре 2024 года поступило современное оборудование — дентальный томограф. Этот аппарат позволяет получать высококачественные цифровые изображения в формате 3D. Врачи теперь могут выявлять сложные случаи и различные патологии в челюстно-лицевой области.</p>",
            link: "https://proamursk.ru/news/1354/"
        },

        // 11 Набережная
        {
            title: "Городская набережная",
            address: null,
            desc: "<p>Любимое место отдыха амурчан — городская набережная, комплексное благоустройство которой длилось несколько лет. Территория преобразилась при поддержке федеральных и краевых программ, за счет средств жителей города, а также благодаря помощи компании «Полиметалл». На набережной теперь есть обустроенные территории отдыха, смотровые площадки, современные беседки необычных форм (ротонды и перголы), информационные стенды экологической тематики.</p>",
            link: "https://proamursk.ru/news/1090/"
        },

        // 12 Ангел-хранитель
        {
            title: "Скульптура «Ангел-хранитель добра и мира», городская набережная",
            address: null,
            desc: "<p>Ангел-хранитель — новый символ Амурска, который при поддержке «Полиметалла» был открыт к юбилею города и района в 2023 году.</p><p>Скульптура высотой 3,5 метра полностью отлита из бронзы. Ангела установили на сферу, представляющую земной шар, а в руках он держит голубку мира. Создатель скульптуры — Петр Стронский, заслуженный художник РФ. Аналогичные фигуры установлены в более чем 30 городах России и мира.</p>",
            link: "https://proamursk.ru/news/864/"
        },

        // 13 Городская библиотека
        {
            title: "Городская библиотека",
            address: "Комсомольский пр-т, 63",
            desc: "<p>В 2022 году на базе учреждения реализован проект по созданию модельной библиотеки. На средства федерального бюджета в рамках нацпроекта «Культура» полностью модернизировано пространство библиотеки, приобретена красивая мебель и современное оборудование, проведен капитальный ремонт, оснащен компьютерами читальный зал. Кроме того, библиотечный фонд обновился более 1400 экземплярами книг.</p><p>При финансовой поддержке «Полиметалла» в учреждении отремонтировали фойе, служебные помещения, изготовили световую вывеску для фасада библиотеки.</p>",
            link: "https://proamursk.ru/news/931/"
        },

        // 14 Натуралист
        {
            title: "Детский эколого-биологический центр «Натуралист»",
            address: "пр-т Строителей, 35",
            desc: "<p>С 2013 года при поддержке «Полиметалла» совместно с «Натуралистом» реализуется эколого-просветительский проект «Здоровая среда — дело каждого». Ежегодно участниками различных мероприятий проекта становятся более 1500 человек. Проводятся акции по высадке деревьев, сбору вторичного сырья, экологические субботники, экспедиции, научные тематические конференции, занятия в «Умной теплице» и эколого-химической лаборатории.</p><p>Также на территории «Натуралиста» обустроена экотропа, где представлены эндемики Дальнего Востока.</p>",
            link: "https://proamursk.ru/reports/146/"
        },

        // 15 Аллея Комсомольского проспекта
        {
            title: "Аллея Комсомольского проспекта",
            address: null,
            desc: "<p>Благодаря финансовой помощи «Полиметалла» новый облик приобрела пешеходная аллея главного проспекта города — Комсомольского. Там появились современные лавочки, фонари, дорожки и парковки. Пространство теперь красивое и комфортное для прогулок. Причем проектировщики постарались сохранить концепцию общественной территории, которую придумали еще первостроители города.</p>",
            link: "https://proamursk.ru/news/1100/"
        },

        // 16 Ремонт улицы Амурской
        {
            title: "Улица Амурская",
            address: null,
            desc: "<p>В 2024 году при финансовой поддержке компании «Полиметалл» завершен капитальный ремонт участка автомобильной дороги и тротуаров — от начала улицы Амурской до памятного камня первостроителям города. На этом участке дороги расположены важные социальные объекты Амурска — спортивная школа, Дом молодежи и набережная.</p>",
            link: "https://proamursk.ru/news/1170/"
        },

        // 17 Территория льда
        {
            title: "ЛХК «Территория льда»",
            address: "пр-т Мира, 38В",
            desc: "<p>Современный ледовый хоккейный комплекс «Территория льда» начал свою работу в декабре 2021 года. Привлечь инвестора в Амурск для строительства крупного и многофункционального объекта помог «Полиметалл». Сегодня «Территория льда» — это не просто ледовая арена, это настоящий центр развития ледового спорта в Амурске.</p><p>При поддержке компании на базе арены проводятся турниры по хоккею краевого и дальневосточного уровня, культурные мероприятия с участием ведущих артистов Хабаровского края. Здесь действует единственная на Дальнем Востоке секция по адаптивному фигурному катанию для детей с ментальными нарушениями, повысилась доступность ледовых видов спорта для социально незащищенных слоев населения.</p>",
            link: "https://proamursk.ru/reports/299/"
        },

        // 18 Центр творчества «Темп»
        {
            title: "МБУ Центр творчества «Темп»",
            address: "пр-т Победы, 8А",
            desc: "<p>Центр «Темп» пользуется большой популярностью среди юных амурчан. Помощь в развитии многих творческих направлений оказывает «Полиметалл». Вместе с компанией центр открыл секцию робототехники, оснастив наборами конструкторов, тренировочными полями для современных роботов, мультимедийным оборудованием.</p><p>Кроме того, были приобретены ноутбуки и профессиональные материалы для детской анимационной студии. На ее базе в 2023 году реализован проект по созданию мультфильмов экологической тематики.</p>",
            link: "https://proamursk.ru/news/1180/"
        },

        // 19 Комсомольская площадь
        {
            title: "Комсомольская площадь",
            address: "Комсомольский пр-т, 48",
            desc: "<p>Комсомольская площадь является одним из главных общественных пространств Амурска. В 2024 году завершена реконструкция площади. Старое покрытие из двух плит заменено на брусчатку, обновлена прогулочная территория за экспозицией «Икар над Амуром», благоустроена смотровая площадка.</p><p>Работы выполнены по федеральной программе формирования комфортной городской среды и за счет инвестиций «Полиметалла».</p>",
            link: null
        },

        // 20 Детский сад № 49
        {
            title: "Детский сад № 49<br>комбинированного вида",
            address: "пр-т Строителей, 29А",
            desc: "<p>В специализированном детском саду № 49 проходят образовательные занятия с ребятами, имеющими ограниченные возможности здоровья, благодаря собственным методическим разработками преподавателей и воспитателей, а также материальному оснащению за счет финансирования от компании «Полиметалл». За несколько лет при поддержке социального партнера для учрежденияприобретена новая мебель, интерактивное оборудование и образовательные системы, учебные пособия.</p>",
            link: "https://proamursk.ru/news/602/"
        },

        // 21 Стадион «Юность»
        {
            title: "Стадион «Юность»",
            address: "ул. Амурская, 3А",
            desc: "<p>Стадион «Юность» — один из ключевых спортивных объектов города и района. Здесь тренируются более тысячи спортсменов, проходят соревнования и массовые мероприятия. ​Трибуны вмещают 5000 зрителей, а площадь поля составляет почти 1000 квадратных метров.</p><p>Ежегодно на стадионе проходят различные спортивные мероприятия, в том числе и при поддержке компании: спартакиада металлургов, соревнования «Семья, футбол и я», корпоративный турнир по футболу на кубок «Полиметалла» и другие.</p>",
            link: "https://proamursk.ru/places/7/"
        },

        // 22 Дом молодежи
        {
            title: "Дом молодежи»",
            address: "ул. Амурская, 8",
            desc: "<p>Дом молодежи — место притяжения школьников, студентов и работающей молодежи. Здесь располагается редакция районного телевидения, ежегодно проходят городские и районные мероприятия, а также работают детская изостудия, фитнес-клуб и студия детского телевидения.</p><p>В 2024 году благодаря краевой субсидии и финансовой поддержки «Полиметалла на базе Дома молодежи открылось современное молодежное пространство. Для этого был проведен ремонт, закуплено необходимое оборудование и мебель. Сейчас в новом помещении молодые амурчане могут работать над проектами, проводить интеллектуальные игры, мастер-классы, организовывать лекции и полезные встречи с экспертами в разных направлениях.</p>",
            link: "https://proamursk.ru/news/1341/"
        },

        // 23 Школа № 2
        {
            title: "МБОУ СОШ № 2",
            address: "ул. Школьная, 9",
            desc: "<p>Благодаря финансовой поддержке «Полиметалла» в школе № 2 отремонтированы и оснащены необходимым оборудованием кабинеты естественнонаучного направления. Также были заменены окна в здании, отремонтированы все санузлы, приведена в порядок кровля в переходе между корпусами школ, над актовым и спортивным залом, над бассейном.</p><p>В 2024 году новый облик получил школьный стадион — здесь появилось современное покрытие беговых дорожек, теннисного корта и футбольного поля, волейбольной площадки и территории для сдачи норм ГТО. Кроме того, благодаря социнвестициям отремонтирована стена бассейна школы.</p>",
            link: "https://proamursk.ru/news/1356/"
        },

        // 24 Школа № 3
        {
            title: "МБОУ СОШ № 3",
            address: "пр-т Победы, 14а",
            desc: "<p>В школе № 3 капитально отремонтирована кровля, проведен ремонт в санузлах, старые деревянные оконные блоки заменены на современные пластиковые.</p><p>Кроме того, благодаря социальным инвестициям «Полиметалла» в учреждении обустроена химическая лаборатория: закуплено необходимое оборудование и реактивы для проведения практических занятий. Также на грантовые средства компании в школе появились комплекты VR-очков: современное цифровое оборудование включает более 300 обучающих уроков по разным предметам.</p>",
            link: "https://proamursk.ru/news/641/"
        },

        // 25 Школа № 5
        {
            title: "МБОУ ООШ им. Р.А.&nbsp;Турского&nbsp;№&nbsp;5",
            address: "Комсомольский пр-т, 7А",
            desc: "<p>Благодаря финансовой поддержке «Полиметалла» в школе № 5 обновлен и оснащен необходимым оборудованием класс химии и биологии. Также проведен ремонт в кабинете физики: отреставрированы парты, заменено напольное покрытие и лаборантский уголок. Кроме того, на грантовые средства компании приобретены наглядные пособия, методические материалы и комплекты химических реактивов. Школьники могут углубленно заниматься предметами естественнонаучного направления: готовиться к олимпиадам и ЕГЭ, а также проводить исследовательские работы.</p>",
            link: "https://proamursk.ru/reports/281/"
        },

        // 26 Школа № 6
        {
            title: "МБОУ СОШ № 6",
            address: "Октябрьский пр-т, 2А",
            desc: "<p>В школе № 6 при финансовой поддержке «Полиметалла» отремонтировали кабинеты физики, химии, биологии, кабинет логопеда-дефектолога. Кроме того, на грантовые средства компании в библиотечной зоне учреждения установили информационную панель и две интеллектуальные лавочки. Также произведен ремонт санузлов и заменены старые деревянные оконные блоки на новые пластиковые стеклопакеты.</p>",
            link: "https://proamursk.ru/news/1000/"
        },

        // 27 Школа № 7
        {
            title: "МБОУ НОШ № 7",
            address: "Октябрьский пр-т, 22",
            desc: "<p>На грантовые средства «Полиметалла» в школе № 7 приобретены интерактивные парты для работы учителя-логопеда. Встроенное программное обеспечение содержит более 2500 разнообразных заданий и уроков. За одной такой партой одновременно смогут работать три ученика, а за один день можно провести семь групповых занятий.</p><p>Также в учреждении благодаря социнвестициям проведен ремонт и оснащение спортивного зала.</p>",
            link: null
        },

        // 28 Школа № 4
        {
            title: "МБОУ Школа № 4",
            address: "Комсомольский пр-т, 47",
            desc: "<p>Школа № 4 имеет коррекционный профиль, здесь ребята занимаются по специальным адаптивным программам. В учреждении благодаря поддержке компании «Полиметалл» создан целый «Мир профессий»: оборудованы кабинеты под рабочие места в разных направлениях. Школьники могут «примерить» на себя профессии повара, парикмахера, электрика, сантехника, столяра, продавца. Такие занятия помогают ребятам сделать выбор, в какой сфере они хотели бы работать.</p>",
            link: "https://proamursk.ru/news/1140/"
        },

        // 29 Школа № 9
        {
            title: "МБОУ СОШ № 9",
            address: "Комсомольский пр-т, 81А",
            desc: "<p>В школе № 9 при финансовой поддержке «Полиметалла» отремонтированы и оснащены оборудованием профильные учебные классы естественнонаучного направления. Теперь у ребят есть все необходимое, чтобы углубленно изучать физику, химию и биологию: современные микроскопы, колбы, пробирки, реактивы. Кроме того, на грантовые средства компании в школу приобретено оборудование для кабинета иностранных языков.</p><p>Благодаря социнвестициям «Полиметалла» в учреждении отремонтирована стеклянная часть кровли.</p>",
            link: "https://proamursk.ru/news/413/"
        },

        // 30 Школа-интернат № 14
        {
            title: "КГКОУ ШИ № 14",
            address: "пр-т Строителей, 16",
            desc: "<p>В школе-интернате № 14 при поддержке «Полиметалла» произошли приятные перемены: обновлен спортивный зал и приобретено новое оборудование, произведен ремонт раздевалок и санитарных узлов.</p><p>Кроме того, на средства компании отремонтирован класс для занятий с психологом и кабинет ранней помощи детям от 0 до 3 лет. А благодаря финансированию из краевого бюджета школа-интернат приобрела необходимое оборудование: стол с кинетическим песком, логопедический замок с интерактивным экраном, тактильную доску, ландшафтный стол и другие развивающие комплексы.</p>",
            link: "https://proamursk.ru/news/933/"
        },

        // 31 Детский сад № 9
        {
            title: "МБДОУ № 9",
            address: "пр-т Мира, 22Б",
            desc: "<p>В детском саду № 9 старые оконные блоки заменены на современные пластиковые стеклопакеты. Сейчас в помещениях учреждения светло, тепло и уютно. Также отремонтированы все туалетные комнаты: каждая оформлена в приятной цветовой гамме и оснащена удобной сантехникой. Кроме того, благодаря социнвестициям «Полиметалла» для детского сада выполнена рабочая документация для ремонта учреждения в целом.</p>",
            link: null
        },

        // 32 Детский сад № 14
        {
            title: "МБДОУ № 14",
            address: "Комсомольский пр-т, 13А",
            desc: "<p>В детском саду № 14 при финансовой поддержке «Полиметалла» старые оконные блоки заменены на современные пластиковые стеклопакеты. Сейчас в помещениях учреждения светло, тепло и уютно. Также отремонтированы все туалетные комнаты: каждая оформлена в приятной цветовой гамме и оснащена удобной сантехникой.</p>",
            link: null
        },

        // 33 Детский сад № 15
        {
            title: "МБДОУ № 15",
            address: "ул. Пионерская, 8А",
            desc: "<p>В детском саду № 15 проведены работы по замене старых оконных блоков на современные пластиковые стеклопакеты. Сейчас в помещениях учреждения светло, тепло и уютно. Также отремонтированы все туалетные комнаты: каждая оформлена в приятной цветовой гамме и оснащена удобной сантехникой. Кроме того, благодаря социнвестициям «Полиметалла» для детского сада выполнена рабочая документация для ремонта учреждения в целом.</p>",
            link: null
        },

        // 34 Детский сад № 17
        {
            title: "МБДОУ № 17",
            address: "пр-т Строителей, 18А",
            desc: "<p>В детском саду № 17 при финансовой поддержке «Полиметалла» проведены работы по замене старых оконных блоков на современные пластиковые стеклопакеты. Сейчас в помещениях учреждения светло, тепло и уютно. Также отремонтированы все туалетные комнаты: каждая оформлена в приятной цветовой гамме и оснащена удобной сантехникой.</p>",
            link: "https://proamursk.ru/news/1224/"
        },

        // 35 Детский сад № 21
        {
            title: "МБДОУ № 21",
            address: "Октябрьский пр-т, 16А",
            desc: "<p>При финансовой поддержке «Полиметалла», а также благодаря собственным средствам учреждения в детском саду № 21 заменены все старые деревянные оконные блоки на современные пластиковые стеклопакеты.</p><p>Кроме того, компания помогла реализовать проект по работе с детьми, имеющими ограниченные возможности здоровья. На собственные средства детский сад отремонтировал помещение, создав необходимое образовательное пространство. А за счет социнвестиций приобретены интерактивный пол, развивающий стол и набор «Дары Фрёбеля».</p>",
            link: null
        },

        // 36 Детский сад № 48
        {
            title: "МБДОУ № 48",
            address: "пр-т Строителей, 56А",
            desc: "<p>В детском саду № 48 при финансовой поддержке «Полиметалла» проведены работы по замене старых оконных блоков на современные пластиковые стеклопакеты. Сейчас в помещениях учреждения светло, тепло и уютно. Также отремонтированы все туалетные комнаты: каждая оформлена в приятной цветовой гамме и оснащена удобной сантехникой.</p>",
            link: "https://proamursk.ru/news/1368/"
        },

        // 37 Детский сад № 52
        {
            title: "МБДОУ № 52",
            address: "пр-т Строителей, 56А",
            desc: "<p>При финансовой поддержке «Полиметалла», а также благодаря собственным средствам учреждения в детском саду № 52 проведены работы по замене старых оконных блоков на современные пластиковые стеклопакеты. Сейчас в помещениях учреждения светло, тепло и уютно. Кроме того, отремонтированы все туалетные комнаты: каждая оформлена в приятной цветовой гамме и оснащена удобной сантехникой.</p>",
            link: "https://proamursk.ru/news/1368/"
        },

        // 38 Детский дом № 12
        {
            title: "КГКУ Детский дом № 12",
            address: "пр-т Строителей, 58А",
            desc: "<p>В 2022 году «Полиметалл» принял участие в софинансировании ремонта кровли детского дома, основная часть средств была выделена из краевого бюджета.</p><p>А уже в 2023 году за счет средств компании завершилось комплексное благоустройство прилегающей территории детского дома. В итоге получилась полноценная площадка для прогулок, игр и занятий спортом воспитанников — с ровными заасфальтированными дорожками, новым забором, футбольным полем, качелями, детским игровым городком и тренажерами.</p>",
            link: "https://proamursk.ru/news/1141/"
        },

        // 39 Центр «Юность»
        {
            title: "МАУ ДО «Юность»",
            address: "ул. Лесная, 4А",
            desc: "<p>В 2021 году благодаря социнвестициям «Полиметалла» в центре допобразования был реконструирован универсальный спортивный зал для занятий фехтованием и теннисом. Помещение стало современным, удобным, светлым и красивым. Кстати, возрождение фехтования в Амурске началось в 2005 году и именно на базе «Юности». Воспитанники центра регулярно занимают призовые места в краевых, всероссийских и международных соревнованиях.</p><p>Также при поддержке компании для центра допобразования было приобретено спортивное оборудование. Всего в «Юности» открыто девять  различных направлений для занятий с детьми.</p>",
            link: "https://proamursk.ru/news/667/"
        },

        // 40 Краеведческий музей
        {
            title: "Амурский городской краеведческий музей",
            address: "Комсомольский пр-т, 9",
            desc: "<p>В разные годы за счет социнвестиций «Полиметалла» в Амурском краеведческом музее проводились ремонт помещений и обновление основной экспозиции.</p><p>А одним из крупных проектов, который был реализован в краеведческом музее Амурска при поддержке компании, стало приобретение цифрового комплекса для проведения занятий и экскурсий в новом формате. В учреждении установлен мультимедийный стол и интерактивный пол. Посетители могут, например, поучаствовать в увлекательных раскопках или отправиться в космос. В комплекте современного оборудования — более 15 образовательных программ.</p>",
            link: "https://proamursk.ru/news/742/"
        },

        // 41 Школа искусств
        {
            title: "Детская школа искусств",
            address: "пр-т Мира, 22А",
            desc: "<p>Благодаря социнвестициям «Полиметалла» в Школе искусств заменили окна и покрытие в танцевальном зале, а также приобрели новые балетные станки.</p><p>Кроме того, большую поддержку компании получает образцовый ансамбль классического танца «Золушка», который занимается на базе Школы искусств. Для артистов регулярно приобретается танцевальная обувь, финансируются выезды коллектива на творческие конкурсы различного уровня. Коллектив «Золушка» четыре раза был признан лучшим детским хореографическим коллективом Хабаровского края, является многократным призером и лауреатом краевых, российских, международных фестивалей и конкурсов.</p>",
            link: null
        },

        // 42 Художественная школа
        {
            title: "Художественная школа",
            address: "Комсомольский пр-т, 67",
            desc: "<p>«Полиметалл» оказал содействие в разработке проектно-сметной документации на ремонт учреждения, что помогло школе войти в программы помощи и получить федеральное финансирование.</p><p>Также в разные годы компания помогала приобретать специализированное оборудование. Ранее в учреждении был обустроен компьютерный класс. А в 2024 году благодаря социнвестициям закуплены новые компьютеры, что позволило развивать в учреждении направление графического дизайна и компьютерной графики.</p><p>Также «Полиметалл» оказал поддержку школе в развитии нового направления — скульптуры и керамики. Для этого были приобретены муфельные печи, гончарные круги и станки.</p>",
            link: "https://proamursk.ru/news/1377/"
        },

        // 43 Музыкальная школа
        {
            title: "Детская музыкальная школа",
            address: "Октябрьский пр-т, 6",
            desc: "<p>В 2014 году «Полиметалл» оказал финансовую помощь в приобретении для музыкальной школы высококлассного концертного рояля фирмы Steinway&Sons, аналогов которому не было в Амурске.</p><p>Музыкальная школа при поддержке компании смогла значительно укрепить свою материально-техническую базу — приобрести русские народные музыкальные инструменты, а также концертную одежду для хора. Новое оборудование помогает юным оркестрантам добиваться еще больших творческих успехов в конкурсах различного уровня.</p>",
            link: "https://proamursk.ru/news/161/"
        },

        // 44 Гостиница «Родник»
        {
            title: "Гостиница «Родник»",
            address: "пр-т Мира, 22В",
            desc: "<p>«Родник» — одно из самых популярных мест в городе. Здесь проводят праздники, торжественные мероприятия, свадебные фотосессии. Ранее компания «Полиметалл» помогла привлечь инвестора для восстановления гостиничного комплекса.</p>",
            link: "https://proamursk.ru/city-guides/3/"
        },

        // 45 Районная библиотека
        {
            title: "Межпоселенческая центральная библиотека Амурского муниципального района имени К.Р.&nbsp;Выборова",
            address: "Комсомольский пр-т, 13",
            desc: "<p>При финансовой поддержке «Полиметалла» в 2024 году в учреждении были заменены старые оконные блоки на новые современные стеклопакеты.</p><p>Кроме того, на базе учреждения в 2025 году планируется создать модельную библиотеку. Финансирование на эти цели предусмотрено по нацпроекту «Семья» при федеральной поддержке с привлечением дополнительных средств в рамках социального партнерства с «Полиметаллом». В планах — обновление пространства, пополнение книжного фонда на 2600 экземпляров, приобретение мультимедийного оборудования.</p>",
            link: "https://proamursk.ru/reports/297/"
        },

        // 46 Декорирование фальшфасадов (пр-т Строителей, 8, 10, 12, 13, 14, 15)
        {
            title: "Декорирование фальшфасадов брошенных домов",
            address: "пр-т Строителей, 8, 10, 12, 13, 14, 15",
            desc: "<p>При финансовой поддержке «Полиметалла» семь пустующих многоэтажек в центре Амурска укрыты декоративными фасадами. Фасады изготовлены из высокопрочного материала, что помогает сохранить конструктив зданий и обеспечить безопасность, ограничить доступ жителей на территорию здания. Дизайн фасадов яркий и цветной, что придает домам эстетичный внешний вид.</p>",
            link: "https://proamursk.ru/news/236/"
        },

        // 47 Декорирование фальшфасадов (Комсомольский пр-т, 8)
        {
            title: "Декорирование фальшфасадов брошенных домов",
            address: "Комсомольский пр-т, 8",
            desc: "<p>При финансовой поддержке «Полиметалла» семь пустующих многоэтажек в центре Амурска укрыты декоративными фасадами. Фасады изготовлены из высокопрочного материала, что помогает сохранить конструктив зданий и обеспечить безопасность, ограничить доступ жителей на территорию здания. Дизайн фасадов яркий и цветной, что придает домам эстетичный внешний вид.</p>",
            link: "https://proamursk.ru/news/165/"
        },

        // 48 Благоустройство дворов (ул. Амурская, 2, 6, 8)
        {
            title: "Благоустройство дворов и&nbsp;детская площадка рядом с&nbsp;Домом молодежи",
            address: "ул. Амурская, 2, 6, 8",
            desc: "<p>При финансовой поддержке «Полиметалла» благоустроены дворы многоквартирных домов в разных уголках Амурска. Дизайн-проекты каждой территории тщательно продуманы проектировщиками — предусмотрены игровые, спортивные и развивающие зоны для детей, установлены новые скамейки и песочницы.</p><p>Также свой облик изменило пространство рядом с Домом молодежи. На месте бывшего ледового комплекса появилась благоустроенная освещенная площадка с лавочками, качелями и детским городком.</p>",
            link: null
        },

        // 49 Благоустройство дворов (Комсомольский пр-т, 4)
        {
            title: "Благоустройство дворов",
            address: "Комсомольский пр-т, 4",
            desc: "<p>При финансовой поддержке «Полиметалла» благоустроены дворы многоквартирных домов в разных уголках Амурска. Дизайн-проекты каждой территории тщательно продуманы проектировщиками — предусмотрены игровые, спортивные и развивающие зоны для детей, установлены новые скамейки и песочницы.</p>",
            link: null
        },

        // 50 Благоустройство дворов (Комсомольский пр-т, 83–85)
        {
            title: "Благоустройство дворов",
            address: "Комсомольский пр-т, 83–85",
            desc: "<p>При финансовой поддержке «Полиметалла» благоустроены дворы многоквартирных домов в разных уголках Амурска. Дизайн-проекты каждой территории тщательно продуманы проектировщиками — предусмотрены игровые, спортивные и развивающие зоны для детей, установлены новые скамейки и песочницы.</p>",
            link: null
        },

        // 51 Благоустройство дворов (Октябрьский пр-т, 7)
        {
            title: "Благоустройство дворов",
            address: "Октябрьский пр-т, 7",
            desc: "<p>При финансовой поддержке «Полиметалла» благоустроены дворы многоквартирных домов в разных уголках Амурска. Дизайн-проекты каждой территории тщательно продуманы проектировщиками — предусмотрены игровые, спортивные и развивающие зоны для детей, установлены новые скамейки и песочницы.</p>",
            link: null
        }

    ];

    $('.js-sp-change-together-show-pop-up').on('click', function () {
        var popUpOuterWrap = $('.pop-up-wrapper.sp-change-together-map-object'),
            dataMapObject = parseInt($(this).data('map-object')),
            cover = $(this).data('cover'),
            title = spChangeTogetherMapObjects[dataMapObject-1].title ? spChangeTogetherMapObjects[dataMapObject-1].title : null,
            address = spChangeTogetherMapObjects[dataMapObject-1].address ? spChangeTogetherMapObjects[dataMapObject-1].address : null,
            desc = spChangeTogetherMapObjects[dataMapObject-1].desc ? spChangeTogetherMapObjects[dataMapObject-1].desc : null,
            link = spChangeTogetherMapObjects[dataMapObject-1].link ? spChangeTogetherMapObjects[dataMapObject-1].link : null;

        hidePopUps();

        popUpOuterWrap.find('.sp-change-together-pop-up__cover').attr('src', cover).removeClass('hidden');

        if (title) popUpOuterWrap.find('.sp-change-together-pop-up__title').html(title).removeClass('hidden');
        else popUpOuterWrap.find('.sp-change-together-pop-up__title').html('').addClass('hidden');

        if (address) {
            popUpOuterWrap.find('.sp-change-together-pop-up__address_inner').html(address);
            popUpOuterWrap.find('.sp-change-together-pop-up__address').removeClass('hidden');

        }
        else {
            popUpOuterWrap.find('.sp-change-together-pop-up__address_inner').html('');
            popUpOuterWrap.find('.sp-change-together-pop-up__address').addClass('hidden');
        };

        if (desc) popUpOuterWrap.find('.sp-change-together-pop-up__desc').html(desc).removeClass('hidden');
        else popUpOuterWrap.find('.sp-change-together-pop-up__desc').html('').addClass('hidden');
        
        if (link) popUpOuterWrap.find('.sp-change-together-pop-up__link').attr('href', link).removeClass('hidden');
        else popUpOuterWrap.find('.sp-change-together-pop-up__link').attr('href', '').addClass('hidden');

        showBodyCover(popUpOuterWrap);
        popUpOuterWrap.addClass('visible');
        popUpAlwaysVisible();
        $('body').addClass('popup-open');
    });


    // Map Drag And Drop

    var isMapDragAndDropStart = false,
        mapDragAndDropContainerStartLeft = 0,
        mapDragAndDropContainerStartTop = 0,
        mapDragAndDropEventStartLeft = 0,
        mapDragAndDropEventStartTop = 0;

    $('.sp-change-together-map__container').css('left', ($('.sp-change-together-map__wrap').width() - $('.sp-change-together-map__container').width()) / 2 + 'px');

    $('.sp-change-together-map__container').css('top', ($('.sp-change-together-map__wrap').height() - $('.sp-change-together-map__container').height()) / 2 + 'px');

    $('.sp-change-together-map__image').on('mousedown touchstart', function(event) {
        var mapContainer = $('.sp-change-together-map__container');

        isMapDragAndDropStart = true;
        mapDragAndDropContainerStartLeft = parseInt(mapContainer.css('left'));
        mapDragAndDropContainerStartTop = parseInt(mapContainer.css('top'));
        
        $('.sp-change-together-map__image').addClass('drag');

        if (event.touches) {
            mapDragAndDropEventStartLeft = event.touches[0].pageX;
            mapDragAndDropEventStartTop = event.touches[0].pageY;

            event.preventDefault();
        }
        else {
            mapDragAndDropEventStartLeft = event.pageX;
            mapDragAndDropEventStartTop = event.pageY;
        }
    });

    $(document).on('mousemove touchmove', function(event) {
        if (isMapDragAndDropStart) {
            var mapContainer = $('.sp-change-together-map__container'),
                mapWrap = $('.sp-change-together-map__wrap'),
                mapContainerLeft = 0,
                mapContainerTop = 0;

            if (event.touches) {
                mapContainerLeft = mapDragAndDropContainerStartLeft + event.touches[0].pageX - mapDragAndDropEventStartLeft;
                mapContainerTop = mapDragAndDropContainerStartTop + event.touches[0].pageY - mapDragAndDropEventStartTop;
            }
            else {
                mapContainerLeft = mapDragAndDropContainerStartLeft + event.pageX - mapDragAndDropEventStartLeft;
                mapContainerTop = mapDragAndDropContainerStartTop + event.pageY - mapDragAndDropEventStartTop;
            }

            if (mapContainerLeft > 0) mapContainerLeft = 0;
            if (mapContainerTop > 0) mapContainerTop = 0;
            if (mapContainer.width() + mapContainerLeft < mapWrap.width()) mapContainerLeft = mapWrap.width() - mapContainer.width();
            if (mapContainer.height() + mapContainerTop < mapWrap.height()) mapContainerTop = mapWrap.height() - mapContainer.height();

            mapContainer.css('left', mapContainerLeft + 'px');
            mapContainer.css('top', mapContainerTop + 'px');
        }
    });

    $(document).on('mouseup touchend', function() {
        isMapDragAndDropStart = false;
        $('.sp-change-together-map__image').removeClass('drag');
    });

    $('.sp-change-together-map__container').on('dragstart', function() {
        return false;
    });

    $(window).on('resize', function() {
        var mapContainer = $('.sp-change-together-map__container'),
                mapWrap = $('.sp-change-together-map__wrap'),
                mapContainerLeft = parseInt(mapContainer.css('left')),
                mapContainerTop = parseInt(mapContainer.css('top'));

        if (mapContainer.width() + mapContainerLeft < mapWrap.width()) mapContainerLeft = mapWrap.width() - mapContainer.width();
        if (mapContainer.height() + mapContainerTop < mapWrap.height()) mapContainerTop = mapWrap.height() - mapContainer.height();

        mapContainer.css('left', mapContainerLeft + 'px');
        mapContainer.css('top', mapContainerTop + 'px');
    });
}